module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAf0lEQVQ4T2NkoBAwUqifAcOAqVOn8rCwsEz/8+dPZnZ29hdCFmB1wYwZM/IZGRlD/vz540nIEJxeINYQvGFAjCEEA5GQIQQNAAUizJDnz5+7NjQ0/EAOWNobQJEXCGkGeYU20UiMzbCAxHBBQ0MDh6Sk5GyKkjKh9E9yNOIzEAAlcmARDAvNzAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/update/index_content_more.png
// module id = 1191
// module chunks = 41